


export const DOMAINLIST_START = 'DOMAINLIST_START';
export const DOMAINLIST_END = 'DOMAINLIST_END';
export const DOMAINLIST_ERROR = 'DOMAINLIST_ERROR';
export const DOMAINLIST_SUCCESS = 'DOMAINLIST_SUCCESS';
export const DOMAINLIST_FAIL = 'DOMAINLIST_FAIL';
export const DOMAINLISTDROPDOWN_SUCCESS ='DOMAINLISTDROPDOWN_SUCCESS';
export const DOMAINLIST_ERRORMESSAGE = 'DOMAINLIST_ERRORMESSAGE';